import { IMessage } from '@core/models';
import { createReducer, on } from '@ngrx/store';
import { cloneDeep } from 'lodash';

import { delAlert } from '../actions';
import { addAlert, cleanAlerts, setAlerts } from '../actions/alerts.actions';

export const alertsInitialState: IMessage[] = [];

export const alertsReducer = createReducer(
  alertsInitialState,

  on(setAlerts, (state, { value }): IMessage[] => state.concat(value)),

  on(addAlert, (state, { value }): IMessage[] => {
    const addMsg: IMessage[] = cloneDeep(state);
    addMsg.push(value);
    return addMsg;
  }),

  on(delAlert, (state, { value }): IMessage[] => state.filter((alert) => alert.id !== value)),

  on(cleanAlerts, (): IMessage[] => [])
);
